export default "__VITE_ASSET__CgKO1Z4a__"